import React from 'react';
import PropTypes from 'prop-types';
import isDefined from '../components/shared/FormBuilder/utils/isDefined';
import { bankFormList } from '../submissions/components/SelectForms';
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';

 export default class AdditionalFormSelector extends React.Component {
    constructor(props) {
        super(props);
        const name = this.props.data.name;
        const initialValue = this.props.initialValues[name];
        const selectedforms = isDefined(initialValue) ? initialValue.split(',') : [];
        const selectedformsArray = this.props.data.attributes.options.filter((option, index) => {
            if (selectedforms.includes(option.value)) {
                return (
                    option
                )
            }
        });
        this.state = {
            value: isDefined(initialValue) ? initialValue : [],
            selectedOptions: isDefined(selectedformsArray) ? selectedformsArray : [],
        };
        this.handleChangeEvent = this.handleChangeEvent.bind(this);
    }

     componentWillReceiveProps(nextProps) {
        if (nextProps.hidden) {
            this.setState({value: '', selectedOptions: []})
        }
    }

     handleChangeEvent(event) {
        let selectedValueArray = [];
        event.map(object => {
            selectedValueArray = [...selectedValueArray, object.value]
        })
        const insuredValue = selectedValueArray.toString();
        this.setState({
            value: insuredValue,
            selectedOptions: event,
        });
        this.props.handleFormChange();
    }

     render() {
        return (
            <div className="col-xs-12 pad_10_0 AdditionalInsuredSelectorContainer">
                <label className="col-xs-4 quoteTitle">{this.props.data.text}
                    {this.props.data.conditionalText && <div className="conditionalText">{this.props.data.conditionalText}</div>}
                </label>
                <div className="select">
                    <div className="col-xs-8 nopad selectFormDropdown" id={this.props.data.name} value={this.state.value}>

                         <ReactMultiSelectCheckboxes
                            className="col-xs-12"
                            // options={formOptions}
                            options={this.props.data.attributes.options}
                            value={this.state.selectedOptions}
                            onChange={this.handleChangeEvent}
                            placeholderButtonLabel=""
                        />
                    </div>
                </div>
                {this.props.data.showFormsList && bankFormList.map((forms, index) => {
                    return (
                        <div key={index} className="showForms">{forms}</div>
                    );
                })}
                {this.props.data.helper && <div className="helper">{this.props.data.helper}</div>}
            </div>
        )
    }
}
AdditionalFormSelector.propTypes = {
    handleFormChange: PropTypes.func,
    initialValues: PropTypes.object,
};